// extracted by mini-css-extract-plugin
export default {"container":"video-document_container__1Yt-v","video":"video-document_video__3S62S"};